"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
const useIsDarkMode = () => {
    const theme = (0, styles_1.useTheme)();
    return theme.palette.mode === "dark";
};
exports.default = useIsDarkMode;
